module.exports = __webpack_public_path__ + "img/image-1.01b14d97.webp";